import React, { useState, useEffect } from 'react'
import Styles from './pointedBar.module.css'

const PointedBar = (props) => {
    const parentCallBack = props.handleChange
    const [value, setValue] = useState(props.initial)
    const [position, setPosition] = useState(5)
    useEffect(() => {
        setValue(props.initial)
    }, [props.initial])
    const handleChange = (e) => {
        setValue(e.target.value)
        const pos = Number(e.target.value)
        const val = +((props.initial / 5) * pos).toFixed(3)
        parentCallBack(val)
        setPosition(pos)
        setValue(val)
    }
    return (
        <div>
            <h1>{value}</h1>
            <input
                className={Styles.bar}
                type="range"
                step='1'
                min='1'
                max='25'
                onChange={handleChange}
                value={position}
            />
        </div>
    )
}

export default PointedBar